import { ErrorsService } from "./../../../../services/common/errors.service";
import { TranslateService } from "@ngstack/translate";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSelectChange,
} from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";
import { SoundEnum } from "src/app/enums/sound.enum";
import { SnackBarService } from "./../../../../services/common/snackBar.service";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { HidService } from "src/app/services/common/hid.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-send-document',
  templateUrl: './send-document.component.html',
  styleUrls: ['./send-document.component.css']
})
export class SendDocumentComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  personInfo: any;
  errObject: any;
  queryParams: any;
  form: FormGroup;
  nationalCode: string;
  errors = new Array();
  nationalcodeForm: FormGroup;
  isUpdate:boolean;
  isSuccessFileUpload: any;
  fileList=[];
  discountsType=[];
  discount: any;

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private hidService: HidService,
    private studentService:StudentService,
    public dialogRef: MatDialogRef<SendDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
    if(this.data){
      this.isUpdate=true;
    }else{
      this.isUpdate=false;
    }
    this.queryParams = {
      holdingEncryptId : this.hidService.getHID()
    };
    this.getdiscountGroupPerson();

  }

    createForm() {
     
      this.form = this.fb.group({
        Id:[this.data && this.data.Id ? this.data.Id.toString() : null],
        Files:[this.data && this.data.Files ? this.data.Files : null,Validators.required],
        Explain:[this.data && this.data.Explain ? this.data.Explain : ""],
        DiscountGroupId:[this.data && this.data.DiscountGroupId ? this.data.DiscountGroupId : null,Validators.required]
      });
    }

  getdiscountGroupPerson():any{

    this.studentService.discountGroupPersonList(this.queryParams).subscribe(res => {
      this.discountsType = res.DataList;
    });
  }
  getDiscount(discountId: MatSelectChange):void{
   
    this.discount=this.discountsType.find(x => x.Id==discountId);
  }
  onFileChange(event) {
   let files=[];
   for(const element of event.target.files) {
    files.push(element);
  }
      if (files) {
        files.forEach((item,key)=> {
            this.fileList.push({FileDisplayName:item.name});
        if (item.size <= 500000) {
          const reader = new FileReader();
          reader.onload = this._handleReaderLoaded.bind(this,key);
          reader.readAsBinaryString(item);
          this.isSuccessFileUpload=true;

        } else {
          this.isSuccessFileUpload=false;

          this.snackBar.OpenSnackBar(

            this.translate.get("require.fileUpload", {
              size: "500kb"
            }),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
  });
}

  }

  _handleReaderLoaded(key,readerEvt) {
    this.fileList[key].ImageData=btoa(readerEvt.target.result);
  }

  submit(form:any) {
   
    this.errors = new Array();
    if (this.isUpdate) {
      let command={
       // HoldingEncriptId:this.hidService.getHID(),
        Id:form.Id,
        DiscountGroupId: form.DiscountGroupId,
      }
      this.studentService.editDocument(command).subscribe(() => {
       
        this.dialogRef.close();
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );

    } else {
      let command={
        HoldingEncriptId:this.hidService.getHID(),
        Explain:form.Explain,
        DiscountGroupId: form.DiscountGroupId,
        FileList: this.fileList
      }
      this.studentService.sendDocument(command).subscribe(() => {
       
        this.dialogRef.close();
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
